import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft } from '@fortawesome/free-regular-svg-icons';
import { useDispatch } from 'react-redux';
import { updateSelectedEventIdDH } from '../../features/ebl/slices/eBLDocumentHistorySlice';
import { useBackNavigation } from '../../../hooks/BackNavigation';
import { useNavigate } from 'react-router-dom';
import { Card } from "react-bootstrap";

const EBLConsentHeader = () => {
	const navigate = useNavigate();
	const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';

  const dispatch = useDispatch();
  const goBack = useBackNavigation(false);

    const onBack = () => {
      dispatch(updateSelectedEventIdDH(null));
      if (window.history.length > 1) {
        goBack();
      } else {
        navigate(`${APP_PATH_PREFIX}/home`);
      }
    };

  return (
    <Card.Header className='d-flex align-items-center border-bottom sticky-top bg-white'>
      <FontAwesomeIcon
        icon={faArrowAltCircleLeft}
        className="text-warning me-3 cursor-pointer"
        size="lg"
        onClick={onBack}
      />

      <h2 className='fs-0 text-primary mt-2'>{'Authority and Confirmation of Terms for eBL Processing'}</h2>

    </Card.Header>
  );
};

export default EBLConsentHeader;
